import React from "react";

/**
 * Compliance + branding footer displayed on public "Book a Consultation" pages
 * (OnboardingForm & SchedulingPage). Copy is fixed per Reliserve Wealth legal
 * requirements — do NOT modify wording without confirming with the founder.
 */
export default function ConsultationFooter() {
  return (
    <footer
      className="mt-16 border-t border-black/10 bg-white/60 backdrop-blur-sm"
      data-testid="consultation-footer"
    >
      <div className="mx-auto max-w-3xl space-y-4 px-6 py-10 text-[12px] leading-relaxed text-muted-foreground">
        <p>
          <b>Reliserve Pulse</b> is the client onboarding, management, and service portal of{" "}
          <b>Reliserve Wealth</b>. Your information is encrypted and used solely to prepare for
          your consultation — we never share your details with third parties. For any concerns,
          write to{" "}
          <a
            href="mailto:grievance@reliservewealth.com"
            className="text-primary underline underline-offset-2"
            data-testid="footer-grievance-mail"
          >
            grievance@reliservewealth.com
          </a>
          . Learn more at{" "}
          <a
            href="https://reliservewealth.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2"
            data-testid="footer-main-site"
          >
            reliservewealth.com
          </a>
          .
        </p>

        <p>
          Reliserve Wealth is the brand / trade name under which <b>Rohan Ghotage</b>, who is an
          AMFI-registered Mutual Fund Distributor (ARN: 369518) and an IRDAI-registered Insurance
          Agent, operates.
        </p>
        <p>
          <b>IRDAI Insurance Agent appointments:</b> Non-Life Insurer —
          ICICI Lombard General Insurance Company Ltd. (Agency Code: ILG50017, Date of
          Appointment: 13 Jun 2019). Life Insurer — Axis Max Life Insurance Co. Ltd.
          (Agency Code: MAX42874H, Date of Appointment: 26 Aug 2026).
        </p>

        <p>
          Mutual Fund investments are subject to market risks; please read all scheme-related
          documents carefully before investing. Insurance is a subject matter of solicitation.
          Past performance is not indicative of future returns. We do not guarantee returns on
          any investment or insurance product. Our general approach is to use insurance
          primarily for protection and separate instruments for wealth creation, though the
          right mix always depends on individual circumstances.
        </p>

        <p>
          <b>Grievance Redressal:</b> If you have a concern about our service, please write to{" "}
          <a
            href="mailto:grievance@reliservewealth.com"
            className="text-primary underline underline-offset-2"
          >
            grievance@reliservewealth.com
          </a>{" "}
          or use our Grievance Redressal Form for a tracked response. Unresolved complaints
          relating to mutual funds may be escalated to{" "}
          <a
            href="https://www.amfiindia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2"
          >
            AMFI
          </a>
          , and those relating to insurance to{" "}
          <a
            href="https://www.irdai.gov.in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2"
          >
            IRDAI
          </a>{" "}
          or the Insurance Ombudsman.
        </p>
      </div>
    </footer>
  );
}
